"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.RefAuditReasonKey = exports.RefAuditCategory = exports.RefAuditAction = void 0;
var RefAuditAction;
(function (RefAuditAction) {
    RefAuditAction["Create"] = "CREATE";
    RefAuditAction["Update"] = "UPDATE";
    RefAuditAction["Delete"] = "DELETE";
    RefAuditAction["Read"] = "READ";
})(RefAuditAction = exports.RefAuditAction || (exports.RefAuditAction = {}));
var RefAuditCategory;
(function (RefAuditCategory) {
    RefAuditCategory["CrfData"] = "CRF:DATA";
    RefAuditCategory["CrfQuery"] = "CRF:QUERY";
    RefAuditCategory["CrfItemSdv"] = "CRF:ITEM:SDV";
    RefAuditCategory["CrfItemFreezing"] = "CRF:ITEM:FREEZING";
    RefAuditCategory["CrfItemLocking"] = "CRF:ITEM:LOCKING";
    RefAuditCategory["CrfSdv"] = "CRF:SDV";
    RefAuditCategory["CrfFreezing"] = "CRF:FREEZING";
    RefAuditCategory["CrfEsign"] = "CRF:ESIGN";
    RefAuditCategory["CrfSecondEsign"] = "CRF:SECOND_ESIGN";
    RefAuditCategory["CrfLocking"] = "CRF:LOCKING";
    RefAuditCategory["CdmsLabTest"] = "CDMS:LAB_TEST";
    RefAuditCategory["CdmsLabNormalRange"] = "CDMS:LAB_NORMAL_RANGE";
    RefAuditCategory["BuilderRtsmRandomization"] = "BUILDER:RTSM:RANDOMIZATION";
    RefAuditCategory["BuilderRtsmIpm"] = "BUILDER:RTSM:IPM";
    RefAuditCategory["PreSubjectReserved"] = "PRE_SUBJECT:RESERVED";
})(RefAuditCategory = exports.RefAuditCategory || (exports.RefAuditCategory = {}));
var RefAuditReasonKey;
(function (RefAuditReasonKey) {
    RefAuditReasonKey["StudySubjectCreate"] = "STUDY_SUBJECT_CREATE";
    RefAuditReasonKey["StudySubjectInitializationStatusUpdatedToProcessing"] = "STUDY_SUBJECT_INITIALIZATION_STATUS_UPDATED_TO_PROCESSING";
    RefAuditReasonKey["StudySubjectInitializationStatusUpdatedToProcessed"] = "STUDY_SUBJECT_INITIALIZATION_STATUS_UPDATED_TO_PROCESSED";
    RefAuditReasonKey["StudySubjectInitializationStatusUpdatedToFail"] = "STUDY_SUBJECT_INITIALIZATION_STATUS_UPDATED_TO_FAIL";
    //
    RefAuditReasonKey["StudySubjectMigrate"] = "STUDY_SUBJECT_MIGRATE";
    RefAuditReasonKey["StudySubjectInit"] = "STUDY_SUBJECT_INIT";
    RefAuditReasonKey["StudySubjectVisitAdd"] = "STUDY_SUBJECT_VISIT_ADD";
    RefAuditReasonKey["StudySubjectVisitRemove"] = "STUDY_SUBJECT_VISIT_REMOVE";
    RefAuditReasonKey["StudySubjectVisitInit"] = "STUDY_SUBJECT_VISIT_INIT";
    RefAuditReasonKey["StudySubjectCrfInit"] = "STUDY_SUBJECT_CRF_INIT";
    RefAuditReasonKey["StudySubjectCrfEsignOn"] = "STUDY_SUBJECT_CRF_ESIGN_ON";
    RefAuditReasonKey["StudySubjectCrfEsignOff"] = "STUDY_SUBJECT_CRF_ESIGN_OFF";
    RefAuditReasonKey["StudySubjectCrfSecondEsignOn"] = "STUDY_SUBJECT_CRF_SECOND_ESIGN_ON";
    RefAuditReasonKey["StudySubjectCrfSecondEsignOff"] = "STUDY_SUBJECT_CRF_SECOND_ESIGN_OFF";
    RefAuditReasonKey["StudySubjectCrfPageAdd"] = "STUDY_SUBJECT_CRF_PAGE_ADD";
    //
    RefAuditReasonKey["StudySubjectSubjectNoUpdated"] = "STUDY_SUBJECT_SUBJECT_NO_UPDATED";
    RefAuditReasonKey["StudySubjectAllocated"] = "STUDY_SUBJECT_ALLOCATED";
    RefAuditReasonKey["StudySubjectRandomized"] = "STUDY_SUBJECT_RANDOMIZED";
    RefAuditReasonKey["StudySubjectAgeUpdated"] = "STUDY_SUBJECT_AGE_UPDATED";
    RefAuditReasonKey["StudySubjectSexUpdated"] = "STUDY_SUBJECT_SEX_UPDATED";
    RefAuditReasonKey["StudySubjectBirthDateUpdated"] = "STUDY_SUBJECT_BIRTH_DATE_UPDATED";
    RefAuditReasonKey["StudySubjectIcfApprovedDateUpdated"] = "STUDY_SUBJECT_ICF_APPROVED_DATE_UPDATED";
    RefAuditReasonKey["StudySubjectECoaAccessCodeUpdated"] = "STUDY_SUBJECT_ECOA_ACCESS_CODE_UPDATED";
    RefAuditReasonKey["StudySubjectStatusUpdatedToRegistration"] = "STUDY_SUBJECT_STATUS_UPDATE_TO_REGISTRATION";
    RefAuditReasonKey["StudySubjectStatusUpdatedToEnrolled"] = "STUDY_SUBJECT_STATUS_UPDATE_TO_ENROLLED";
    RefAuditReasonKey["StudySubjectStatusUpdatedToScreening"] = "STUDY_SUBJECT_STATUS_UPDATE_TO_SCREENING";
    RefAuditReasonKey["StudySubjectStatusUpdatedToScreeningFailed"] = "STUDY_SUBJECT_STATUS_UPDATE_TO_SCREENING_FAILED";
    RefAuditReasonKey["StudySubjectStatusUpdatedToOngoing"] = "STUDY_SUBJECT_STATUS_UPDATE_TO_ONGOING";
    RefAuditReasonKey["StudySubjectStatusUpdatedToDroppedOut"] = "STUDY_SUBJECT_STATUS_UPDATE_TO_DROPPED_OUT";
    RefAuditReasonKey["StudySubjectStatusUpdatedToCompleted"] = "STUDY_SUBJECT_STATUS_UPDATE_TO_COMPLETED";
    RefAuditReasonKey["StudySubjectVisitDateUpdated"] = "STUDY_SUBJECT_VISIT_DATE_UPDATED";
    RefAuditReasonKey["StudySubjectReservedUpdated"] = "STUDY_SUBJECT_RESERVED_UPDATED";
    RefAuditReasonKey["StudySubjectRandomizationNoDeleted"] = "STUDY_SUBJECT_RANDOMIZATION_NO_DELETED";
    //
    RefAuditReasonKey["StudySubjectEdcDataCaptured"] = "STUDY_SUBJECT_EDC_DATA_CAPTURED";
    RefAuditReasonKey["StudySubjectEdcDataStriked"] = "STUDY_SUBJECT_EDC_DATA_STRIKED";
    RefAuditReasonKey["StudySubjectEdcDataUnStriked"] = "STUDY_SUBJECT_EDC_DATA_UN_STRIKED";
    //
    RefAuditReasonKey["StudySubjectTriggerInvokeAllExplicitly"] = "STUDY_SUBJECT_TRIGGER_INVOKE_ALL_EXPLICITLY";
    RefAuditReasonKey["StudySubjectQueryDeprecated"] = "STUDY_SUBJECT_QUERY_DEPRECATED";
    RefAuditReasonKey["StudySubjectQueryAllowEmpty"] = "STUDY_SUBJECT_QUERY_ALLOW_EMPTY";
    RefAuditReasonKey["StudySubjectCrfRefresh"] = "STUDY_SUBJECT_CRF_REFRESH";
    //
    RefAuditReasonKey["StudySubjectEdcSdvAutoRelease"] = "STUDY_SUBJECT_EDC_SDV_AUTO_RELEASE";
    RefAuditReasonKey["StudySubjectEdcEsignAutoRelease"] = "STUDY_SUBJECT_EDC_ESIGN_AUTO_RELEASE";
    RefAuditReasonKey["StudySubjectEdcSecondEsignAutoRelease"] = "STUDY_SUBJECT_EDC_SECOND_ESIGN_AUTO_RELEASE";
    //
    RefAuditReasonKey["StudySubjectSigningStatusChanged"] = "STUDY_SUBJECT_SIGNING_STATUS_CHANGED";
    //
    RefAuditReasonKey["StudySubjectUnblindRequest"] = "STUDY_SUBJECT_UNBLIND_REQUEST";
    RefAuditReasonKey["StudySubjectUnblindApprove"] = "STUDY_SUBJECT_UNBLIND_APPROVE";
    RefAuditReasonKey["StudySubjectUnblindForceUnderConds"] = "STUDY_SUBJECT_UNBLIND_FORCE_UNDER_CONDITIONS";
    RefAuditReasonKey["StudySubjectUnblindForce"] = "STUDY_SUBJECT_UNBLIND_FORCE";
    //
    RefAuditReasonKey["EcoaDataCaptured"] = "ECOA_DATA_CAPTURED";
    //
    RefAuditReasonKey["StudyIpDeliveryAutoRequested"] = "STUDY_IP_DELIVERY_AUTO_REQUESTED";
    RefAuditReasonKey["StudyIpDeliveryRequested"] = "STUDY_IP_DELIVERY_REQUESTED";
    RefAuditReasonKey["StudyIpDeliveryApproved"] = "STUDY_IP_DELIVERY_APPROVED";
    RefAuditReasonKey["StudyIpDeliveryStarted"] = "STUDY_IP_DELIVERY_STARTED";
    RefAuditReasonKey["StudyIpDeliveryCanceled"] = "STUDY_IP_DELIVERY_CANCELED";
    RefAuditReasonKey["StudyIpDeliveryConfirmed"] = "STUDY_IP_DELIVERY_CONFIRMED";
    //
    RefAuditReasonKey["StudyUsedIpReturnRequested"] = "STUDY_USED_IP_RETURN_REQUESTED";
    RefAuditReasonKey["StudyUsedIpReturnCanceled"] = "STUDY_USED_IP_RETURN_CANCELED";
    RefAuditReasonKey["StudyUsedIpReturnConfirmed"] = "STUDY_USED_IP_RETURN_CONFIRMED";
    RefAuditReasonKey["StudyUnusedIpReturnRequested"] = "STUDY_UNUSED_IP_RETURN_REQUESTED";
    RefAuditReasonKey["StudyUnusedIpReturnCanceled"] = "STUDY_UNUSED_IP_RETURN_CANCELED";
    RefAuditReasonKey["StudyUnusedIpReturnConfirmed"] = "STUDY_UNUSED_IP_RETURN_CONFIRMED";
    //
    RefAuditReasonKey["StudySubjectContactCreate"] = "STUDY_SUBJECT_CONTACT_CREATE";
    RefAuditReasonKey["StudySubjectContactUpdated"] = "STUDY_SUBJECT_CONTACT_UPDATED";
    RefAuditReasonKey["StudySubjectContactDeleted"] = "STUDY_SUBJECT_CONTACT_DELETED";
    //
    RefAuditReasonKey["StudySubjectCodingMigrated"] = "STUDY_SUBJECT_CODING_MIGRATED";
    //
    RefAuditReasonKey["StudySubjectCrfDisabled"] = "STUDY_SUBJECT_CRF_DISABLED";
    RefAuditReasonKey["StudySubjectCrfActivated"] = "STUDY_SUBJECT_CRF_ACTIVATED";
    RefAuditReasonKey["StudySubjectCrfVisited"] = "STUDY_SUBJECT_CRF_VISITED";
    RefAuditReasonKey["StudySubjectCrfUnVisited"] = "STUDY_SUBJECT_CRF_UNVISITED";
    //
    RefAuditReasonKey["StudySubjectCycleLikeVisitsAdded"] = "STUDY_SUBJECT_CYCLELIKE_VISITS_ADDED";
    RefAuditReasonKey["StudySubjectCycleLikeVisitsRemoved"] = "STUDY_SUBJECT_CYCLELIKE_VISITS_REMOVED";
    //
    RefAuditReasonKey["EsignSuccess"] = "ESIGN_SUCCESS";
    RefAuditReasonKey["EsignFail"] = "ESIGN_FAIL";
    //
    RefAuditReasonKey["StudyUatOpen"] = "STUDY_UAT_OPEN";
    RefAuditReasonKey["StudyUatClose"] = "STUDY_UAT_CLOSE";
    //
    RefAuditReasonKey["StudyUatSubmitted"] = "STUDY_UAT_SUBMITTED";
    RefAuditReasonKey["StudyUatAccepted"] = "STUDY_UAT_ACCEPTED";
    RefAuditReasonKey["StudyUatApplied"] = "STUDY_UAT_APPLIED";
    RefAuditReasonKey["StudyUatCompleted"] = "STUDY_UAT_COMPLETED";
    RefAuditReasonKey["StudyUatCanceled"] = "STUDY_UAT_CANCELED";
    RefAuditReasonKey["StudyUatAutoCanceled"] = "STUDY_UAT_AUTO_CANCELED";
    //
    RefAuditReasonKey["StudyUatMovedToNextSequence"] = "STUDY_UAT_MOVED_TO_NEXT_SEQUENCE";
    RefAuditReasonKey["StudyUatMigrated"] = "STUDY_UAT_MIGRATED";
    //
    RefAuditReasonKey["StudyUatCommentAdded"] = "STUDY_UAT_COMMENT_ADDED";
    RefAuditReasonKey["StudyUatCommentUpdated"] = "STUDY_UAT_COMMENT_UPDATED";
    RefAuditReasonKey["StudyUatCommentMigrated"] = "STUDY_UAT_COMMENT_MIGRATED";
    //
    RefAuditReasonKey["StudySubjectCrfAvailableStatusChanged"] = "STUDY_SUBJECT_CRF_AVAILABLE_STATUS_CHANGED";
    RefAuditReasonKey["StudySubjectCrfDisableStatusChanged"] = "STUDY_SUBJECT_CRF_DISABLE_STATUS_CHANGED";
    //
    RefAuditReasonKey["StudyLabTestAdded"] = "STUDY_LAB_TEST_ADDED";
    RefAuditReasonKey["StudyLabTestUpdated"] = "STUDY_LAB_TEST_UPDATED";
    RefAuditReasonKey["StudyLabTestDestroyed"] = "STUDY_LAB_TEST_DESTROYED";
    //
    RefAuditReasonKey["StudyLabNormalRangeAdded"] = "STUDY_LAB_NORMAL_RANGE_ADDED";
    RefAuditReasonKey["StudyLabNormalRangeUpdated"] = "STUDY_LAB_NORMAL_RANGE_UPDATED";
    //
    RefAuditReasonKey["StudyTrainingPageAdded"] = "STUDY_TRAINING_PAGE_ADDED";
    RefAuditReasonKey["StudyTrainingPageUpdated"] = "STUDY_TRAINING_PAGE_UPDATED";
    RefAuditReasonKey["StudyTrainingQuestionAdded"] = "STUDY_TRAINING_QUESTION_ADDED";
    RefAuditReasonKey["StudyTrainingQuestionUpdated"] = "STUDY_TRAINING_QUESTION_UPDATED";
    RefAuditReasonKey["StudyTrainingAnswerAdded"] = "STUDY_TRAINING_ANSWER_ADDED";
    RefAuditReasonKey["StudyTrainingAnswerUpdated"] = "STUDY_TRAINING_ANSWER_UPDATED";
    RefAuditReasonKey["StudyTrainingRenewalDelayed"] = "STUDY_TRAINING_RENEWAL_DELAYED";
    RefAuditReasonKey["StudyTrainingRenewalDelayInfoDestroyed"] = "STUDY_TRAINING_RENEWAL_DELAY_INFO_DESTROYED";
    //
    RefAuditReasonKey["StudyCustomDataCrfFileCreated"] = "STUDY_CUSTOM_DATA_CRF_FILE_CREATED";
    RefAuditReasonKey["StudyCustomDataCrfFileRequested"] = "STUDY_CUSTOM_DATA_CRF_FILE_REQUESTED";
    RefAuditReasonKey["StudyCustomDataCrfFileDownloaded"] = "STUDY_CUSTOM_DATA_CRF_FILE_DOWNLOADED";
    //
    RefAuditReasonKey["StudyDuplicatedCrfPageDestroyed"] = "STUDY_DUPLICATED_CRF_PAGE_DESTROYED";
    //
    RefAuditReasonKey["StudyDataIntegrationAttachmentFileCaptured"] = "STUDY_DATA_INTEGRATION_ATTACHMENT_FILE_CAPTURED";
})(RefAuditReasonKey = exports.RefAuditReasonKey || (exports.RefAuditReasonKey = {}));
//# sourceMappingURL=resource.js.map